import { type KickPlate } from 'metalworks-domain'

import { DistanceDimensionInput, GenericDimensionInput } from '@salsita-ai/platform-project-sdk/react'
import { EntityPanel, PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

import {
  FinishDirectionProperty,
  FinishProperty,
  HandingProperty,
  MaterialSwatchProperty,
  NonStandardMaterialWarningWrapper,
  PowderCoatingProperty,
  PowderCoatingWarningWrapper,
  ThicknessProperty,
} from './shared-property-page-components'

interface Props {
  id: KickPlate['id']
  standard: boolean
  hasFinishDirection: boolean
  powderCoating: boolean
}

export const KickPlatePropertyPage = (props: Props) => {
  const { id, standard, hasFinishDirection, powderCoating } = props

  return (
    <EntityPanel.Layout
      additionalAction={null}
      header={
        <EntityPanel.Header
          title="Kick Plate"
          description="Customise your kick plate. You can change the length, width and thickness of your plate and select your preferred material."
          previewImage={undefined}
          primaryButton={null}
          secondaryButton={null}
        />
      }
    >
      <PropertyContainer.Group spacing="large">
        <MaterialSwatchProperty id={id} />
        <PowderCoatingProperty id={id} />
        <PowderCoatingWarningWrapper powderCoating={powderCoating} />
        <FinishProperty id={id} />
        {hasFinishDirection && <FinishDirectionProperty id={id} />}
        <HandingProperty id={id} />
        <ThicknessProperty id={id} />
        <NonStandardMaterialWarningWrapper standard={standard} />
        <PropertyContainer.Item title="Width">
          <DistanceDimensionInput entityId={id} instanceName="horizontalLength" />
        </PropertyContainer.Item>
        <PropertyContainer.Item title="Height">
          <DistanceDimensionInput entityId={id} instanceName="verticalLength" />
        </PropertyContainer.Item>
        <PropertyContainer.Item title="Corner Radius">
          <GenericDimensionInput entityId={id} instanceName="cornerRadius" />
        </PropertyContainer.Item>
      </PropertyContainer.Group>
    </EntityPanel.Layout>
  )
}
